/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateExpenseCategoryRequest } from '../models/CreateExpenseCategoryRequest';
import type { CreateExpenseCategorySubheadRequest } from '../models/CreateExpenseCategorySubheadRequest';
import type { ExpenseCategoryDto } from '../models/ExpenseCategoryDto';
import type { ExpenseCategorySubheadDto } from '../models/ExpenseCategorySubheadDto';
import type { Page_ExpenseCategoryDto_ } from '../models/Page_ExpenseCategoryDto_';
import type { UpdateExpenseCategoryRequest } from '../models/UpdateExpenseCategoryRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ExpenseCategoryControllerService {
  /**
   * getExpenseCategories
   * @returns Page_ExpenseCategoryDto_ OK
   * @throws ApiError
   */
  public static getExpenseCategoriesUsingGet({
    xTenantId,
    limit = 10,
    offset,
    search,
  }: {
    /**
     * X-TENANT-ID
     */
    xTenantId: string;
    /**
     * limit
     */
    limit?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Page_ExpenseCategoryDto_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/expense-categories',
      headers: {
        'X-TENANT-ID': xTenantId,
      },
      query: {
        limit: limit,
        offset: offset,
        search: search,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createExpenseCategory
   * @returns ExpenseCategoryDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createExpenseCategoryUsingPost({
    request,
    xTenantId,
  }: {
    /**
     * request
     */
    request: CreateExpenseCategoryRequest;
    /**
     * X-TENANT-ID
     */
    xTenantId: string;
  }): CancelablePromise<ExpenseCategoryDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/expense-categories',
      headers: {
        'X-TENANT-ID': xTenantId,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteExpenseCategorySubhead
   * @returns any OK
   * @throws ApiError
   */
  public static deleteExpenseCategorySubheadUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/expense-categories/subhead/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * editExpenseCategorySubhead
   * @returns ExpenseCategorySubheadDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static editExpenseCategorySubheadUsingPut({
    request,
    subheadId,
  }: {
    /**
     * request
     */
    request: CreateExpenseCategorySubheadRequest;
    /**
     * subheadId
     */
    subheadId: string;
  }): CancelablePromise<ExpenseCategorySubheadDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/expense-categories/subhead/{subheadId}',
      path: {
        subheadId: subheadId,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateExpenseCategory
   * @returns ExpenseCategoryDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateExpenseCategoryUsingPut({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: UpdateExpenseCategoryRequest;
  }): CancelablePromise<ExpenseCategoryDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/expense-categories/{id}',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteExpenseCategory
   * @returns any OK
   * @throws ApiError
   */
  public static deleteExpenseCategoryUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/expense-categories/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * addExpenseCategorySubhead
   * @returns ExpenseCategorySubheadDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static addExpenseCategorySubheadUsingPost({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: CreateExpenseCategorySubheadRequest;
  }): CancelablePromise<ExpenseCategorySubheadDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/expense-categories/{id}/subhead',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
